var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"v-html":_vm.terms.public.general}})}
var staticRenderFns = []

export { render, staticRenderFns }